/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { LocationDTO } from './LocationDTO';
import {
    LocationDTOFromJSON,
    LocationDTOFromJSONTyped,
    LocationDTOToJSON,
} from './LocationDTO';

/**
 * 
 * @export
 * @interface FamilyTypeDTO
 */
export interface FamilyTypeDTO {
    /**
     * 
     * @type {boolean}
     * @memberof FamilyTypeDTO
     */
    active?: boolean;
    /**
     * 
     * @type {string}
     * @memberof FamilyTypeDTO
     */
    id?: string;
    /**
     * 
     * @type {Array<LocationDTO>}
     * @memberof FamilyTypeDTO
     */
    locations?: Array<LocationDTO>;
    /**
     * 
     * @type {string}
     * @memberof FamilyTypeDTO
     */
    name?: string;
}

/**
 * Check if a given object implements the FamilyTypeDTO interface.
 */
export function instanceOfFamilyTypeDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FamilyTypeDTOFromJSON(json: any): FamilyTypeDTO {
    return FamilyTypeDTOFromJSONTyped(json, false);
}

export function FamilyTypeDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyTypeDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'active': !exists(json, 'active') ? undefined : json['active'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'locations': !exists(json, 'locations') ? undefined : ((json['locations'] as Array<any>).map(LocationDTOFromJSON)),
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function FamilyTypeDTOToJSON(value?: FamilyTypeDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'active': value.active,
        'id': value.id,
        'locations': value.locations === undefined ? undefined : ((value.locations as Array<any>).map(LocationDTOToJSON)),
        'name': value.name,
    };
}

